import { PayloadAction, createSlice } from "@reduxjs/toolkit";

interface UserState {
  username: string;
}

const initialState: UserState = {
  username: "",
};

export const userSlice = createSlice({
  name: "user",
  initialState,
  reducers: {
    updateUsername: (state, action: PayloadAction<string>) => {
      state.username = action.payload;
    },
    resetUsername: (state) => {
      state.username = initialState.username;
    },
  },
});

export const { updateUsername, resetUsername } = userSlice.actions;

export default userSlice.reducer;
